<div class="modal-header">
    <h4 class="modal-title fw-bold">
        <span *ngIf="breedingMethodId" jhiTranslate="crop-settings-manager.breeding-method.modal.edit.header"></span>
        <span *ngIf="!breedingMethodId" jhiTranslate="crop-settings-manager.breeding-method.modal.create.header"></span>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm">
        <div class="mb-3 row">
            <label for="breedingMethodName" class="col-sm-5 col-form-label fw-bold" jhiTranslate="crop-settings-manager.breeding-method.modal.breeding-method-name">Breeding Method Name</label>
            <div class="col-sm-7">
                <input type="text" class="form-control" name="name" id="breedingMethodName" [(ngModel)]="breedingMethodRequest.name" #breedingMethodName="ngModel" jhi-forbiddenCharactersValidator [maxLength]="50" [required]="true"/>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="code" class="col-sm-5 col-form-label fw-bold" jhiTranslate="crop-settings-manager.breeding-method.modal.code">Code</label>
            <div class="col-sm-7">
                <input type="text" class="form-control" name="abbreviation" id="code" [(ngModel)]="breedingMethodRequest.code" #code="ngModel" jhi-forbiddenCharactersValidator [maxLength]="8" [required]="true"/>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="description" class="col-sm-5 col-form-label fw-bold" jhiTranslate="crop-settings-manager.breeding-method.modal.description">Description</label>
            <div class="col-sm-7">
                <textarea rows="3" class="form-control" name="description" id="description" [(ngModel)]="breedingMethodRequest.description" #description="ngModel" jhi-forbiddenCharactersValidator [maxLength]="255" [required]="true"></textarea>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="type" class="col-sm-5 control-label fw-bold" jhiTranslate="crop-settings-manager.breeding-method.modal.generation-advancement-type">Generation Advancement Type</label>
            <div class="col-sm-7">
                <select class="form-select" id="type" name="type" [(ngModel)]="breedingMethodRequest.type" #type="ngModel" [required]="true" (change)="generationAdvancementTypeChanged()">
                    <option *ngFor="let breedingMethodType of breedingMethodTypes" [value]="breedingMethodType.code">
                        <label>{{breedingMethodType.name}}</label>
                    </option>
                </select>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="methodGroup" class="col-sm-5 control-label fw-bold" jhiTranslate="crop-settings-manager.breeding-method.modal.crop-reproductive-system">Crop Reproductive System</label>
            <div class="col-sm-7">
                <select class="form-select" id="methodGroup" name="methodGroup" [(ngModel)]="breedingMethodRequest.group" #methodGroup="ngModel">
                    <option *ngFor="let breedingMethodGroup of breedingMethodGroups" [value]="breedingMethodGroup.code">
                        <label>{{breedingMethodGroup.name}}</label>
                    </option>
                </select>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="methodClass" class="col-sm-5 control-label fw-bold" jhiTranslate="crop-settings-manager.breeding-method.modal.class">Class</label>
            <div class="col-sm-7">
                <select class="form-select" id="methodClass" name="methodClass" [(ngModel)]="breedingMethodRequest.methodClass" #methodClass="ngModel" [required]="true">
                    <option *ngFor="let breedingMethodClass of breedingMethodClassesFiltered" [value]="breedingMethodClass.id">
                        <label>{{breedingMethodClass.name}}</label>
                    </option>
                </select>
            </div>
        </div>
        <div *ngIf="isGenerative()">
            <div class="form-group row">
                <label for="numberOfProgenitors" class="col-sm-5 col-form-label fw-bold"
                       jhiTranslate="crop-settings-manager.breeding-method.modal.number-of-progenitors">Number
                    of Progenitors</label>
                <div class="col-sm-7">
                    <input type="number" class="form-control" name="numberOfProgenitors"
                           id="numberOfProgenitors" [(ngModel)]="breedingMethodRequest.numberOfProgenitors"
                           #numberOfProgenitors="ngModel"
                           [min]="0" [max]="2"/>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-5"></div>
                <div class="col-sm-7 mt-1 mb-2"><em
                        jhiTranslate="crop-settings-manager.breeding-method.modal.mprgn-gen-valid-values"></em>
                </div>
            </div>
            <div class="form-group row">
                <label for="numberOfFemaleProgenitors" class="col-sm-5 col-form-label font-weight-bold"
                       jhiTranslate="crop-settings-manager.breeding-method.modal.number-of-female-progenitors">Number
                    of Female Progenitors</label>
                <div class="col-sm-7">
                    <input type="number" class="form-control" name="numberOfFemaleProgenitors"
                           id="numberOfFemaleProgenitors" [(ngModel)]="breedingMethodRequest.numberOfFemaleParents"
                           #numberOfFemaleProgenitors="ngModel"
                           [min]="0" [max]="1" [required]="true"/>
                </div>
            </div>
            <div class="mb-3 row">
                <div class="col-sm-5"></div>
                <div class="col-sm-7 mt-1 mb-2"><em
                        jhiTranslate="crop-settings-manager.breeding-method.modal.mfprg-gen-valid-values"></em>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <div class="col-sm-7">
                <h5 class="fw-bold">
                    <span jhiTranslate="crop-settings-manager.breeding-method.modal.name-rule" style="margin-right: 5px;"></span>
                    <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
                </h5>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="description" class="col-sm-5 col-form-label fw-bold" jhiTranslate="crop-settings-manager.breeding-method.modal.snametype">Source name type</label>
            <div class="col-sm-7">
                <select class="form-select" name="snameTypeId" [(ngModel)]="breedingMethodRequest.snameTypeId" #snameTypeId="ngModel" [required]="false">
                    <option *ngFor="let snameType of snameTypes" [value]="snameType.id">
                        <label>{{snameType.code}}</label>
                    </option>
                </select>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="description" class="col-sm-5 col-form-label fw-bold" jhiTranslate="crop-settings-manager.breeding-method.modal.separator">Separator</label>
            <div class="col-sm-7">
                <input type="text" class="form-control" name="separator" id="separator" [(ngModel)]="breedingMethodRequest.separator" #separator="ngModel" jhi-forbiddenCharactersValidator [maxLength]="255" />
            </div>
        </div>
        <div class="mb-3 row">
            <label for="description" class="col-sm-5 col-form-label fw-bold" jhiTranslate="crop-settings-manager.breeding-method.modal.prefix">Prefix</label>
            <div class="col-sm-7">
                <input type="text" class="form-control" name="prefix" id="prefix" [(ngModel)]="breedingMethodRequest.prefix" #prefix="ngModel" jhi-forbiddenCharactersValidator [maxLength]="255" [required]="breedingMethodRequest?.type === breedingMethodTypeEnum.GENERATIVE" />
            </div>
        </div>
        <div class="mb-3 row">
            <label for="description" class="col-sm-5 col-form-label fw-bold" jhiTranslate="crop-settings-manager.breeding-method.modal.count">Count</label>
            <div class="col-sm-7">
                <input class="form-control" name="count" id="count" [(ngModel)]="breedingMethodRequest.count" #count="ngModel" [maxLength]="255" />
            </div>
        </div>
        <div class="mb-3 row">
            <label for="description" class="col-sm-5 col-form-label fw-bold" jhiTranslate="crop-settings-manager.breeding-method.modal.suffix">Suffix</label>
            <div class="col-sm-7">
                <input type="text" class="form-control" name="suffix" id="suffix" [(ngModel)]="breedingMethodRequest.suffix" #suffix="ngModel" jhi-forbiddenCharactersValidator [maxLength]="255" />
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="cancel"></span>
    </button>
    <button (click)="save()" [disabled]="!isFormValid(f)" class="btn btn-primary">
        <span *ngIf="isLoading" class="throbber throbber-btn"></span>
        <span class="fa fa-save"></span>&nbsp;
        <span *ngIf="breedingMethodId" jhiTranslate="update"></span>
        <span *ngIf="!breedingMethodId" jhiTranslate="create"></span>
    </button>
</div>
